import React, { Component } from "react";
import {
  NormalButtonBackend,
  NormalCheckbox,
  NormalModal,
  NormalInput,
  NormalTable,
  InputSearch
} from "component/common";
import { withTranslation } from "react-i18next";
import {
  ReverseTrmtReason,
  updateCommon,
  Newappointreason,
} from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BsPencilSquare } from "react-icons/bs";
import closeIcon from "assets/images/close.png";
import { Toast } from "service/toast";

export class AdjustmentreasonClass extends Component {
  state = {
    AdjusmentDetails: [
      { label: "Code", divClass: "justify-content-end" },
      { label: "Description" },
      { label: "Is Active" },
      { label: "Action", divClass: "justify-content-center" },
    ],
    List: [],
    is_loading: null,
    isAboutPopModal: false,
    isNewdescPopModal: false,
    newid: null,
    newval: null,
    editid: null,
    editval: null,
    activeitem: true,
    filterdata: [],
    search: "",
  };

  componentDidMount = () => {
    this.ListofReason({});
  };
  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  aboutpopup() {
    this.setState({
      isAboutPopModal: !this.state.isAboutPopModal,
    });
  }

  newdescpopup() {
    let { List, newid, te } = this.state;
    if (List.length > 0) {
      te = List[List.length - 1].revNo;
      newid = Number(te) + 1;
    } else {
      newid = 100001;
    }

    this.setState({
      isNewdescPopModal: !this.state.isNewdescPopModal,
      newid,
    });
  }

  ListofReason = async () => {
    this.updateState({ is_loading: true });
    await this.props.ReverseTrmtReason().then((res) => {
      console.log(res);
      let { List } = this.state;

      List = res;
      console.log(List);
      this.setState({
        List,
        is_loading: false,
      });
      console.log(List.length);
    });
  };

  handleEdit(id, desc, check) {
    let { editid, editval, activeitem } = this.state;
    editid = id;
    editval = desc;
    activeitem = check;
    console.log(editid, editval);
    this.setState({
      editid,
      editval,
      activeitem,
    });
    this.aboutpopup();
  }

  handledesc = ({ target: { value, name } }) => {
    console.log(name);
    let { editval } = this.state;

    if ((name = "desc")) {
      editval = value;
      this.setState({ editval });
    }
  };

  newdescriptionval = ({ target: { value, name } }) => {
    let { newid } = this.state;

    if ((name = "newid")) {
      newid = value;
      this.setState({ newid });
    }
  };

  newdescription = ({ target: { value, name } }) => {
    let { newval } = this.state;

    if ((name = "newdesval")) {
      newval = value;
      this.setState({ newval });
    }
  };

  finaldesc = async (id, desc) => {
    let { editval, newval, activeitem } = this.state;
    let descJson = {
      revNo: id,
      revDesc: desc,
      revRemark: "",
      isActive: activeitem,
    };
    await this.props
      .updateCommon(
        `ReverseTrmtReasons/update?where=%7B%22revNo%22%3A%20%22${id}%22%7D
     `,
        descJson
      )
      .then((data) => {
        this.ListofReason({});
        Toast({
          type: "success",
          message: "Updated Successfully",
        });
      });
    this.aboutpopup();
    editval = "";
    newval = "";
    this.setState({ editval, newval });
  };

  createdesc = async (id, val) => {
    if (val == null) {
      Toast({
        type: "error",
        message: "Description required",
      });
    } else {
      let { newval } = this.state;
      console.log(id, val);
      let newreason = {
        revNo: id,
        revDesc: val,
        revRemark: "",
        isActive: true,
      };
      await this.props
        .Newappointreason(newreason)
        .then((data) => {
          this.ListofReason({});
        })
        .catch((e) => console.log(e));
      this.newdescpopup();
      newval = "";
      this.setState({ newval });
    }
  };

  handlecheckbox = async (item) => {
    let { List } = this.state;
    for (let i = 0; i <= List.length - 1; i++) {
      if (List[i].revNo == item) {
        List[i].isActive = !List[i].isActive;
        let descJson = {
          revNo: List[i].revNo,
          revDesc: List[i].revDesc,
          revRemark: "",
          isActive: List[i].isActive,
        };
        await this.props
          .updateCommon(
            `ReverseTrmtReasons/update?where=%7B%22revNo%22%3A%20%22${item}%22%7D
`,
            descJson
          )
          .then((data) => {
            this.ListofReason({});
          });
      }
    }
  };

  filterByName = ({ target: { value, name } }) => {
    console.log(value, name);
    let { List, filterdata, search, seachdata } = this.state;
    if (name == "search") {
      search = value;
      this.setState({ search });
    }
    if (search !== "") {
      filterdata = List.filter(item => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(search.toLowerCase());
      });
    }
    this.setState({ filterdata });
    console.log(filterdata);
  };

  render() {
    let {
      AdjusmentDetails,
      List,
      is_loading,
      isAboutPopModal,
      editid,
      editval,
      newid,
      newval,
      isNewdescPopModal,
      filterdata,
      search,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div
          className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="mt-3 label-head text-center text-md-left text-lg-left">
                    {t("Treatment")}
                  </h4>
                </div>
              </div>
              <div className="tab-table-content">
                <div className="d-md-flex">
                  <p className="mt-2 col-12 label-title col-md-8 text-center text-md-left text-lg-left">
                    {t("List Of Adjustment Reason")}
                  </p>
                  <div className="col-12 col-md-4 mt-2 mt-md-0">
                    <InputSearch
                      onChange={this.filterByName}
                      placeholder="Search"
                    />
                  </div>
                  </div>
                {search.length > 0 ? (
                  <div className="tab-table-content">
                    <div className="py-4">
                      <div className="table-container">
                        <NormalTable headerDetails={AdjusmentDetails}>
                          {is_loading ? (
                            <tr>
                              <td colSpan="7">
                                <div class="d-flex mt-5 align-items-center justify-content-center">
                                  <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ) : filterdata.length > 0 ? (
                            filterdata.map(
                              ({ revNo, revDesc, isActive }, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div className="text-left">{revNo}</div>
                                    </td>
                                    <td>
                                      <div className="text-left">{revDesc}</div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        <NormalCheckbox
                                          checked={isActive}
                                          name="checked"
                                          onChange={() =>
                                            this.handlecheckbox(revNo)
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        <BsPencilSquare
                                          size={20}
                                          onClick={() =>
                                            this.handleEdit(
                                              revNo,
                                              revDesc,
                                              isActive
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          ) : null}
                        </NormalTable>
                      </div>
                    </div>
                  </div>
                ) : (
                <div className="table-container">
                  <div className="mt-3 col-12">
                    <NormalTable headerDetails={AdjusmentDetails}>
                      {is_loading ? (
                        <tr>
                          <td colSpan="7">
                            <div class="d-flex mt-5 align-items-center justify-content-center">
                              <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : List.length > 0 ? (
                        List.map(({ revNo, revDesc, isActive }, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <div className="text-left text-primary">{revNo}</div>
                              </td>
                              <td>
                                <div className="text-left">{revDesc}</div>
                              </td>
                              <td>
                                <div className="text-left  cursor-pointer">
                                  <NormalCheckbox
                                    checked={isActive}
                                    name="checked"
                                    onChange={() => this.handlecheckbox(revNo)}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="text-left cursor-pointer">
                                  <BsPencilSquare
                                    size={20}
                                    onClick={() =>
                                      this.handleEdit(revNo, revDesc, isActive)
                                    }
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : null}
                    </NormalTable>
                  </div>
                </div>
                )}
              </div>
            </div>
          </div>
          <div className="mt-3 mb-3 col-12 col-md-3" style={{ width: "100%" }}>
            <NormalButtonBackend
              mainbg={true}
              label={"Add Row"}
              onClick={() => this.newdescpopup()}
            />
          </div>
        </div>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isAboutPopModal}
          handleModal={() => this.aboutpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.aboutpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
              <h5> EDIT DESCRIPTION </h5>
            </div>
            <div className="col-12">
              <div className="">
                <h6>Code</h6>
                <NormalInput value={editid} disabled={true} />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={editval}
                  name="desc"
                  onChange={this.handledesc}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.aboutpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.finaldesc(editid, editval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
        <NormalModal
          className={"retail-price-modal"}
          style={{ minWidth: "80%" }}
          modal={isNewdescPopModal}
          handleModal={() => this.newdescpopup()}
        >
          <div className="col-12 mx-auto">
            <div className="d-flex justify-content-end">
              <img
                onClick={() => this.newdescpopup()}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="text-center">
              <h5> ADD DESCRIPTION</h5>
            </div>
            <div className="col-12">
              <div className="">
                <h6>Code</h6>
                <NormalInput
                  value={newid}
                  name="newid"
                  disabled={true}
                  onChange={this.newdescriptionval}
                />
              </div>
              <div className="mt-2">
                <h6>Description</h6>
                <NormalInput
                  value={newval}
                  name="newdesval"
                  onChange={this.newdescription}
                />
              </div>
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Cancel"
                    onClick={() => this.newdescpopup()}
                  />
                </div>
                <div className="col-6">
                  <NormalButtonBackend
                    normal={true}
                    label="Done"
                    onClick={() => this.createdesc(newid, newval)}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ReverseTrmtReason,
      updateCommon,
      Newappointreason,
    },
    dispatch
  );
};

export const Adjustmentreason = withTranslation()(
  connect(null, mapDispatchToProps)(AdjustmentreasonClass)
);
